import { c as _c } from "react/compiler-runtime";
import type { AlgoliaIndexItem } from '@algoacademy/backend/modules/docs/external-functions/queries/algolia-index-item-type';
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { P2, P3 } from '@algoacademy/design-system/web/typography/Paragraph';
import { useEffect, useState } from 'react';
import { getRecentSearches } from './recentSearchesStorage';
export function RecentSearches() {
  const $ = _c(9);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [recent, setRecent] = useState(t0);
  let t1;
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setRecent(getRecentSearches());
    };
    t2 = [];
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (recent.length === 0) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <P2 className="text-center text-contentTertiary">Brak ostatnich wyszukiwań</P2>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <P2 className="text-contentSecondary">Ostatnie wyszukiwania</P2>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== recent) {
    t4 = recent.map(_temp);
    $[5] = recent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <div className="flex flex-col gap-3">{t3}{t4}</div>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}
function _temp(hit) {
  return <Link key={hit.article.id} href={`/baza/${hit.collection.slug}/${hit.article.slug}`} className="group rounded-lg bg-backgroundSecondary px-3 py-3 hover:bg-backgroundBlue hover:text-contentBlue"><P2 className="text-current">{hit.article.name}</P2><P3 className="mt-1 text-contentTertiary group-hover:text-contentBlue">{hit.collection.name}</P3></Link>;
}